import styled from "styled-components";

export const NavContent = styled.nav`
  display: flex;
  gap: 2.3rem;
  align-items: center;

  & > :nth-child(1) {
    display: none;
  }

  & > button {
    position: relative;
    display: flex;
    outline: none;
    border: none;
    background-color: transparent;
    height: 3.9rem;
    width: 3.6rem;
    align-self: center;
    cursor: pointer;

    & > img {
      height: 2.5rem;
      width: 2.5rem;
      align-self: center;
    }

    & > div {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 2rem;
      height: 2.4rem;
      border-radius: 0.7rem;
      background-color: var(--color-primary);
      display: flex;
      align-items: center;
      justify-content: center;
      & > span {
        color: var(--color-white-fixed);
        font-weight: 900;
        font-size: 1.4rem;
      }
    }
  }
  @media (max-width: 680px) {
    & > :nth-child(1) {
      display: block;
    }
    & > :nth-child(2) {
      width: 100%;
      max-width: 40rem;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
    }
    & .buttonCart {
      display: block;
      position: relative;
    }
  }
  @media (max-width: 425px) {
    & > :nth-child(2) {
      max-width: 33rem;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
    }
    & .buttonCart {
      display: block;
      position: relative;
    }
  }
`;
